var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg007PiggyBank(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 59.017 59.017",
    style: {
      enableBackground: "new 0 0 59.017 59.017"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_13_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_118_",
    style: {
      fill: "#F4ADC9"
    },
    d: "M52.789,34.385c-0.091,0.007-0.179,0.027-0.272,0.027c-1.933,0-3.5-1.567-3.5-3.5 c0-1.473,0.912-2.728,2.201-3.244c-1.901-5.09-5.527-8.896-10.073-11.291c-0.004-0.002-0.009-0.002-0.013-0.003 c-0.643,1.555-1.608,2.943-2.825,4.069c-4.661-2.452-10.349-2.231-14.829,0.652c-1.792-1.388-3.151-3.296-3.878-5.492 c-0.024-0.059-0.055-0.112-0.074-0.175c-1.439,0.451-2.703,0.895-3.517,1.235c-4.193-1.703-7.12-2.439-9.684-2.154 c-0.365,0.04-0.434,0.527-0.103,0.686c2.331,1.122,2.739,4.092,3.787,6.314c-3.044,2.932-3.342,5.062-3.879,8.903H4 c-2.87,0-4,2.327-4,5.197v3.607c0,2.87,1.13,5.196,4,5.196h1.314c2.982,8.674,13.452,13.316,24.436,13.316 c13.393,0,23.267-7.718,23.267-19.316C53.017,37.015,52.936,35.674,52.789,34.385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_117_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M16.009,28.912c0,1.381-1.119,2.5-2.5,2.5c-1.381,0-2.5-1.119-2.5-2.5 c0-1.381,1.119-2.5,2.5-2.5C14.89,26.412,16.009,27.531,16.009,28.912"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_116_",
    style: {
      fill: "#E685A5"
    },
    d: "M53.017,38.412c-0.552,0-1-0.448-1-1c0-0.552,0.448-1,1-1c2.206,0,4-1.794,4-4 c0-0.552,0.448-1,1-1c0.552,0,1,0.448,1,1C59.017,35.721,56.326,38.412,53.017,38.412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_115_",
    style: {
      fill: "#E685A5"
    },
    d: "M58.017,33.412c-0.552,0-1-0.448-1-1c0-2.206-1.794-4-4-4c-0.552,0-1-0.448-1-1 c0-0.552,0.448-1,1-1c3.309,0,6,2.691,6,6C59.017,32.965,58.569,33.412,58.017,33.412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_112_",
    style: {
      fill: "#E685A5"
    },
    d: "M52.517,35.412c-2.481,0-4.5-2.019-4.5-4.5c0-2.481,2.019-4.5,4.5-4.5 c2.481,0,4.5,2.019,4.5,4.5C57.017,33.393,54.998,35.412,52.517,35.412 M52.517,28.412c-1.378,0-2.5,1.122-2.5,2.5 c0,1.378,1.122,2.5,2.5,2.5c1.378,0,2.5-1.122,2.5-2.5C55.017,29.534,53.895,28.412,52.517,28.412"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_111_",
    style: {
      fill: "#E685A5"
    },
    d: "M55.961,31.37c-0.14,0-0.282-0.029-0.417-0.091 c-0.502-0.231-0.722-0.825-0.491-1.327c0.603-1.311,0.611-2.817,0.022-4.133c-0.226-0.504,0-1.095,0.504-1.321 c0.502-0.228,1.095-0.001,1.321,0.504c0.825,1.843,0.813,3.951-0.03,5.786C56.703,31.154,56.339,31.37,55.961,31.37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_110_",
    style: {
      fill: "#E685A5"
    },
    d: "M48.735,50.155c-2.414,2.79-5.738,4.91-9.702,6.187l0.296,0.985 c0.21,0.701,0.856,1.182,1.588,1.182h6.017c2.319,0,3.94-2.293,3.169-4.479L48.735,50.155z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_109_",
    style: {
      fill: "#E685A5"
    },
    d: "M8.964,50.266L7.351,54.3c-0.807,2.016,0.678,4.209,2.849,4.209h6.741 c0.438,0,0.833-0.267,0.996-0.675l0.725-1.814C14.833,54.768,11.459,52.843,8.964,50.266"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_108_",
    style: {
      fill: "#E685A5"
    },
    d: "M28.399,54.624c-3.732,0-7.126-0.723-10.513-2.222 c-0.505-0.223-0.733-0.813-0.509-1.319c0.223-0.505,0.813-0.733,1.319-0.51c3.915,1.734,7.684,2.332,12.227,1.939 c0.548-0.058,1.035,0.36,1.082,0.91c0.048,0.551-0.36,1.035-0.91,1.082C30.175,54.584,29.277,54.624,28.399,54.624"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_107_",
    style: {
      fill: "#E685A5"
    },
    d: "M41.879,24.078c-0.256,0-0.512-0.098-0.707-0.293 c-5.364-5.363-14.092-5.363-19.456,0c-0.391,0.391-1.024,0.391-1.414,0c-0.391-0.391-0.391-1.023,0-1.414 c6.143-6.144,16.14-6.144,22.284,0c0.391,0.391,0.391,1.023,0,1.414C42.391,23.98,42.135,24.078,41.879,24.078"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_106_",
    style: {
      fill: "#FFD949"
    },
    d: "M22.692,20.413c4.896-3.273,11.228-3.503,16.332-0.703 c1.849-2.038,2.985-4.733,2.985-7.702c0-6.352-5.149-11.5-11.5-11.5c-6.351,0-11.5,5.148-11.5,11.5 C19.009,15.334,20.434,18.315,22.692,20.413"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_105_",
    style: {
      fill: "#F4BF1A"
    },
    d: "M26.79,18.469c2.625-0.807,5.417-0.907,8.088-0.315 c1.938-1.356,3.208-3.6,3.208-6.145c0-4.142-3.357-7.5-7.5-7.5c-4.142,0-7.5,3.358-7.5,7.5 C23.086,14.764,24.576,17.165,26.79,18.469"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg007PiggyBank);
export default __webpack_public_path__ + "static/media/007-piggy-bank.735468c7a6a9a9da25715d177a56a28d.svg";
export { ForwardRef as ReactComponent };